module.exports = __webpack_public_path__ + "static/media/bg-moebel.4c56d2ac.jpg";